import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../Layout";
import HeaderOrg from "../HeaderOrg";

const UploadOrgEmailSuccess = () => (
  <Layout>
    <HeaderOrg />
    <section className="layout-container">
      <div className="container ctr sp-pad1">
        <div className="bi-success-check">
          <i className="bi bi-check2-circle" alt="Success Checkmark"></i>
        </div>
        <div className="lg-msg">
          Organization email upload has started successfully.
        </div>
        <div className="text-size6 spacer-margin3">
        All emails will be added as soon as possible, depending on the number of emails being processed. <br />To check the current list, please use the button below.
          {/*To check on the status of your upload, use the button below.*/}
                </div>
        <Link to={"/emails"} className="btn btn-primary" role="button">
          Manage Emails
        </Link>
        {/*<Link to={"/upload-status"} className="btn btn-primary" role="button">*/}
        {/*  Upload Status*/}
        {/*</Link>*/}
      </div>
    </section>
  </Layout>
);

export default UploadOrgEmailSuccess;
